import { ref, computed } from 'vue';
import type { User } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';

const _user = ref<User | null>(null);

supabase.auth.getSession().then(({ data }) => {
  _user.value = data.session?.user ?? null;
});

supabase.auth.onAuthStateChange((_event, session) => {
  _user.value = session?.user ?? null;
});

export function useAuth() {
  const isAuthenticated = computed(() => _user.value !== null);

  async function signIn(email: string, password: string): Promise<void> {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;
  }

  async function signOut(): Promise<void> {
    await supabase.auth.signOut();
  }

  return { user: _user, isAuthenticated, signIn, signOut };
}
